import { NotificationsOutlinedIcon } from 'common/icons';
import { NeutralColors, RedColors } from 'theme';

interface NotificationButtonProps {
  hasUnread: boolean;
}

const NotificationButton = ({ hasUnread }: NotificationButtonProps) => {
  return (
    <>
      <style>
        {`
          .notification-button {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 32px;
            background: none;
            border: none;
            cursor: pointer;
            border-radius: 8px;
          }
          .notification-button:hover {
            background-color: ${NeutralColors[10]};
          }
          .notification-button__badge {
            position: absolute;
            top: 0;
            right: 0;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: ${RedColors[50]};
          }
        `}
      </style>
      <button type="button" className="notification-button">
        <NotificationsOutlinedIcon
          style={{ width: 28, height: 28, fill: NeutralColors[60] }}
        />
        {hasUnread && <span className="notification-button__badge" />}
      </button>
    </>
  );
};

export { NotificationButton };
